export default __webpack_public_path__ + "static/media/img12.26a552e5.svg";